import { LinkModel } from '~contentful/models/actions/link.model';
import { ABTestSubjectModel } from '~contentful/models/components/ab-test-subject.model';
import { BannerModel } from '~contentful/models/components/banner.model';
import { ButtonModel } from '~contentful/models/components/button.model';
import { ImageModel } from '~contentful/models/components/image.model';
import { PageModel } from '~contentful/models/components/page.model';
import { ResponsiveImageModel } from '~contentful/models/components/responsive-image.model';
import { StepsHelperStepModel } from '~contentful/models/components/steps-helper-step.model';
import { StepsHelperModel } from '~contentful/models/components/steps-helper.model';
import { Model } from '~contentful/models/model';

export enum ContentModelType {
  Page = 'page',
  Banner = 'banner',
  ABTestSubject = 'abTestSubject',
  Link = 'link',
  StepsHelper = 'stepsHelper',
  StepsHelperStep = 'stepsHelperStep',
  Button = 'button',
  Image = 'image',
  ResponsiveImage = 'responsiveImage',
}

export const ModelDefinitions: {
  [key in ContentModelType]: typeof Model;
} = {
  [ContentModelType.Page]: PageModel,
  [ContentModelType.Banner]: BannerModel,
  [ContentModelType.ABTestSubject]: ABTestSubjectModel,
  [ContentModelType.Link]: LinkModel,
  [ContentModelType.StepsHelper]: StepsHelperModel,
  [ContentModelType.StepsHelperStep]: StepsHelperStepModel,
  [ContentModelType.Button]: ButtonModel,
  [ContentModelType.Image]: ImageModel,
  [ContentModelType.ResponsiveImage]: ResponsiveImageModel,
};
